import { render, staticRenderFns } from "./notifica.vue?vue&type=template&id=88ef7b7a&scoped=true&"
import script from "./notifica.vue?vue&type=script&lang=js&"
export * from "./notifica.vue?vue&type=script&lang=js&"
import style0 from "./notifica.vue?vue&type=style&index=0&id=88ef7b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ef7b7a",
  null
  
)

export default component.exports